module.exports = __webpack_public_path__ + "static/media/empUploadErrorMessage.83a1ea29.svg";